import React, { useEffect, useState } from 'react';

interface AnimatedNumberProps {
  targetValue: number;
}

const animateTime = [100, 500, 1000];

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ targetValue }) => {
  const [currentValue, setCurrentValue] = useState<number>(0);

  useEffect(() => {
    let accumulatedTime = 0;
    const totalDuration = animateTime[String(targetValue).length] || 2000; // animate seconds
    const initialIncrement = totalDuration / targetValue ** 1.5; // initial time step

    const incrementValue = () => {
      setCurrentValue((prevValue) => {
        const newValue = prevValue + 1;
        if (newValue > targetValue) return targetValue;
        if (newValue < targetValue) {
          const nextIncrement = initialIncrement * (1 + (newValue / targetValue) ** 2); // increment time step
          accumulatedTime += nextIncrement;
          setTimeout(incrementValue, nextIncrement);
        }
        return newValue;
      });
    };

    setTimeout(incrementValue, initialIncrement); // kick off the animation
  }, [targetValue]);

  return <span>{currentValue}</span>;
};

export default AnimatedNumber;
